module.exports = __webpack_public_path__ + "static/media/audart-cv-fr.7c2dbcb2.pdf";